import { TableBody, TableCell, TableRow } from '@/components/ui/table';
import type { TableEmptyViewProps } from '../types';

function getEmptyMessage({
  noDataLabel,
  searchValue,
  activeFilterCount,
}: Pick<
  TableEmptyViewProps,
  'noDataLabel' | 'searchValue' | 'activeFilterCount'
>): string {
  const hasSearch = Boolean(searchValue?.trim());
  const hasFilters = Boolean(activeFilterCount && activeFilterCount > 0);

  if (hasSearch && hasFilters) {
    return `No results found for your search with the applied filters`;
  }

  if (hasSearch) {
    return `No results found for your search`;
  }

  if (hasFilters) {
    const filterText = activeFilterCount === 1 ? 'filter' : 'filters';
    return `No results found with ${activeFilterCount} ${filterText} applied`;
  }

  return noDataLabel || 'No data';
}

export function TableEmptyView({
  noDataLabel,
  columnCount,
  searchValue,
  activeFilterCount,
}: TableEmptyViewProps) {
  const message = getEmptyMessage({
    noDataLabel,
    searchValue,
    activeFilterCount,
  });

  return (
    <TableBody>
      <TableRow>
        <TableCell
          colSpan={columnCount}
          className="px-4 py-6 text-center text-muted-foreground"
        >
          {message}
        </TableCell>
      </TableRow>
    </TableBody>
  );
}
